/**
 * components/rightbar/formatSize.ts —— 字节 → 人类可读 sizeText（**公共纯件**·单源）。
 *
 * 归位（L-AU-HYG 卫生批）：原逐字译入 `TextTabBody.tsx`（真源＝102 `utils/file.js::formatSize`），
 * 因 `artifactList.ts` 亦须取用 ⇒ 抽出单源落本件；`TextTabBody`（原址）与 `artifactList` 两处改 import。
 * 🔴 函数行为与签名**一字不变**（只搬移不改写）；`TextTabBody` 保留再导出，兼容 `index.ts` 桶口旧引用面。
 * 口径：对齐 UI设计.md 4.2（"1.8MB" 格式）。
 */

/**
 * 字节 → 人类可读 sizeText（"1.8MB" 格式，对齐 UI设计.md 4.2）
 */
export function formatSize(bytes?: number | null): string {
  if (!bytes && bytes !== 0) return "";
  const n = Number(bytes);
  if (n < 1024) return `${n}B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)}KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)}MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(2)}GB`;
}
